import { render } from "./sfmc-container.vue?vue&type=template&id=343a92a0"
import script from "./sfmc-container.vue?vue&type=script&lang=js"
export * from "./sfmc-container.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__